export class Fadein {
	constructor() {
        this.views = document.querySelectorAll('.cmn_fadein'); // 複数の要素を取得
        this.views.forEach(view => {
            this.load(view);
        });
	}

	load (view) {
		var srcs = [];
		var count = 0;
        view.querySelectorAll('*').forEach(element => {
            if (element.tagName.toLowerCase() === 'img' && element.src) {
                srcs.push(element.src);
            }
            const backgroundImage = window.getComputedStyle(element).backgroundImage;
            const match = backgroundImage.match(/url\("(.+)"\)/);
            if (match) {
                srcs.push(match[1]);
            }
        });
        srcs.forEach(src => {
            const img = new Image();
            img.onload = img.onerror = () => {
                if (++count === srcs.length) {
                    view.classList.add('active'); // 全ての画像が読み込まれたらクラスを追加
                }
            };
            img.src = src;
        });

        // 読み込む画像がない場合はすぐにクラスを追加
        if (!srcs.length) {
            view.classList.add('active');
        }
	}
}
export class Intro {
    constructor() {
        this.view = document.querySelector('.cmn_intro');
        if (this.view) {
            this.load();
        }
    }

    load() {
        const srcs = [];
        let count = 0;

        // 子要素の画像や背景画像を収集
        this.view.querySelectorAll('*').forEach(element => {
            if (element.tagName.toLowerCase() === 'img' && element.src) {
                srcs.push(element.src);
            }
            const backgroundImage = window.getComputedStyle(element).backgroundImage;
            const match = backgroundImage.match(/url\("(.+)"\)/);
            if (match) {
                srcs.push(match[1]);
            }
        });

        // 画像の読み込みをチェック
        srcs.forEach(src => {
            const img = new Image();
            img.onload = img.onerror = () => {
                if (++count === srcs.length) {
                    this.view.classList.add('actiion'); // 全ての画像が読み込まれたらクラスを追加
                }
            };
            img.src = src;
        });

        // 読み込む画像がない場合はすぐにクラスを追加
        if (!srcs.length) {
            this.view.classList.add('actiion');
        }
    }
}
